module.exports = __webpack_public_path__ + "img/unpin.89e4d4a6.svg";